<template>
  <section class="home-steps">
    <b-container>
      <h2 class="home-steps__heading">{{ $t('pages.home.how.title') }}</h2>
      <b-row>
        <b-col
          v-for="number in stepNumbers"
          :key="number"
          cols="12"
          sm="6"
          lg="3"
          class="mb-4 mb-lg-0"
        >
          <div class="step">
            <span class="step__number">{{ number }}</span>
            <h3 class="step__title">{{ $t(`pages.home.how.step${number}.title`) }}</h3>
            <p class="step__text">{{ $t(`pages.home.how.step${number}.text`) }}</p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
  export default {
    name: 'HomeHowItWorks',

    data () {
      return {
        stepNumbers: [1, 2, 3, 4],
      }
    },
  }
</script>

<style scoped>
  .home-steps {
    padding: 3rem 0 2rem;
  }

  .home-steps__heading {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--ui-ink);
    text-align: center;
    margin-bottom: 2rem;
  }

  .step {
    height: 100%;
    padding: 0 0.25rem;
  }

  .step__number {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: var(--ui-brand);
    color: #fff;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.75rem;
  }

  .step__title {
    font-size: 1.0625rem;
    font-weight: 600;
    color: var(--ui-ink);
    margin-bottom: 0.375rem;
  }

  .step__text {
    color: var(--ui-muted);
    margin-bottom: 0;
  }

  @media (min-width: 992px) {
    .home-steps {
      padding: 4rem 0 3rem;
    }
  }
</style>
